import controller from './repre.controller';
import template from './repre.html';

export default {
	template,
	bindings: {
		disabled: '<ngDisabled',
		// Force view (hide view switch button)
		forceView: '<?repreForceView',
		// The base node. Required if you plan to NodeService.update
		node:     '<?',
		options:  '<?',
		// Whether to add or not new representations
		repreAdd: '<',
		// Whether to add or not new representations from rules
		repreInsertOnlyFromRules: '<?',
		validate: '<?repreValidate',
		values:   '<ngModel',
	},
	controller,
	controllerAs: '$ctrl',
	require:      {
		ngModelCtrl: '?ngModel',
		parent:      '^^?kform',
	},
};
